import { NewBuildingWhitelabelEnum } from '@search/graphql-typings';
import { Shared } from '../../types/shared';

const config: Shared.IInstanceConfig = {
    searchIndex: NewBuildingWhitelabelEnum.Default,
    productionBaseUrl: '/',
    productionSearchUrl: '/moskva/novostroyki/',
    host: 'https://m2.ru',
    seoHost: 'm2.ru',
    hasCleanURLs: true,
    rootRegionsType: NewBuildingWhitelabelEnum.Default,
    preferentialMortgageBadgeVariant: 'default',
    hasDeveloperPromo: true,
    hasRepairRequest: false,
    hasOffers: true,
    hasSpecialEvents: true,
    hasDeveloperCallBack: true,
    hasBreadcrumbs: true,
    hasStickyNavbar: true,
    hasFavoritesButton: true,
    hasFavoritesOfferButton: false,
    hasOpenGraph: true,
    showAppleHomeScreenIcon: true,
    hasFullDescription: true,
    hasStats: true,
    hasNews: true,
    hasChat: true,
    hasTradeIn: true,
    hasQuickSelection: true,
    hasCustomerFeedback: true,
    hasInfoURLs: true,
    GTM_ID: {
        default: 'GTM-NZ68V6W,GTM-NL6K6C3',
        production: 'GTM-5X8V29V'
    },
    headerAppName: 'nb-search',
    hasQuiz: true,
    hasQuizIdle: true,
    hasNewBuildingAdd: true,
    CT_ID: {
        testing: 'lmb48t8x',
        production: 'i2czl18z'
    },
    calltouchUnitId: {
        Msk: 20831,
        Spb: 20832
    }
};

export default config;
